export default "__VITE_ASSET__e93d69bb__"